import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15.49 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.99 2.12H9.3c-.28 0-.5.22-.5.5s.22.5.5.5h3.48L6.34 9.56c-.2.2-.2.51 0 .71a.485.485 0 0 0 .7 0l6.44-6.44v3.48c0 .28.22.5.5.5s.5-.22.5-.5V2.62c.01-.27-.22-.5-.49-.5z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13 9.28c-.28 0-.5.22-.5.5v4.51c0 .32-.24.59-.52.59H2.52c-.28 0-.52-.27-.52-.59V4.97c0-.32.24-.59.52-.59H6.7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H2.52C1.68 3.38 1 4.09 1 4.97v9.32c0 .88.68 1.59 1.52 1.59h9.45c.84 0 1.52-.71 1.52-1.59V9.78c.01-.28-.22-.5-.49-.5z"
    }, null, -1)
  ])))
}
export default { render };